import { Box } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TitlebarAction from '../../components/common/TitlebarActions'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import { Link } from 'react-router-dom'
import AreaCreate from '../../components/AreaCreate'
import { useProject } from '../../context/ProjectContext'

export default function AreaCreatePage({ setBlockScreen }: any) {

  const { isProjectUndefined } = useProject()

  return (<>
    <TopSideBar currentSection='companies' disableProjectSelector />

    <PageContainer>

      <Box paddingBottom={PADDING_BASE}>
        <Breadcrumbs pathlist={[
          <Link className='breadcrumbs-nav__link' to="/tickets/listing">
            Home
          </Link>,
          <Link className='breadcrumbs-nav__link' to="/areas/listing">
            Áreas
          </Link>,
          'Nueva']}
        />
      </Box>

      <TitlebarAction
        title='Nueva Área'
      />

      {!isProjectUndefined() && (
        <AreaCreate
          setBlockScreen={setBlockScreen}
        />)}
    </PageContainer>
  </>)
}